<template>
  <div class="login">
    <el-row @click.native="hidedialog">
      <!-- 0 -->
      <el-col v-if="accontPass == 0">
        <div v-if="showForm == 1" class="form-container flex">
          <div class="logo-left">
            <img src="./../assets/login_picture1.png" class="img" />
          </div>
          <div class="login-right">
            <div class="form-container-header">
              <span>
                <a
                  :class="{ active_a: TabPass == 'pass' }"
                  @click="handlerTab('pass')"
                  >密码登录</a
                >
              </span>
              <span>
                <a
                  :class="{ active_a: TabPass == 'code' }"
                  @click="handlerTab('code')"
                  >验证码登录</a
                >
              </span>
            </div>
            <div v-show="TabPass == 'pass'">
              <el-form
                :model="ruleForm1"
                status-icon
                ref="ruleForm1"
                label-style="text-align: center"
                class="demo-ruleForm"
              >
                <el-form-item
                  prop="username"
                  style="text-align: center"
                  :rules="[
                    {
                      required: true,
                      message: '请输入用户名',
                      trigger: 'change',
                    },
                  ]"
                >
                  <el-input
                    placeholder="请输入用户账号/手机号"
                    v-model="ruleForm1.username"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  prop="password"
                  style="text-align: center"
                  :rules="[
                    {
                      required: true,
                      message: '请输入密码',
                      trigger: 'change',
                    },
                  ]"
                >
                  <el-input
                    placeholder="请输入密码"
                    type="password"
                    v-model="ruleForm1.password"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  prop="code"
                  style="text-align: center"
                  :rules="[
                    {
                      required: true,
                      message: '请输入验证码',
                      trigger: 'change',
                    },
                  ]"
                >
                  <!-- :rules="[
                  {
                    required: true,
                    message: '请输入验证码',
                    trigger: 'change',
                  },
                ]" -->
                  <div class="code-container">
                    <el-input
                      placeholder="验证码"
                      @keyup.enter.native="submitForm('ruleForm1')"
                      v-model="ruleForm1.code"
                    ></el-input>
                    <span v-loading="loading">
                      <img
                        @click="handleChangeCode"
                        class="modify-img"
                        :src="modifySrc"
                        alt=""
                      />
                    </span>
                  </div>
                </el-form-item>
                <p style="direction: rtl" class="forgetpwd">
                  <span
                    style="
                      font-size: 14px;
                      font-family: PingFangSC-Regular, PingFang SC;
                      font-weight: 400;
                      color: #ff6161;
                      line-height: 22px;
                      cursor: pointer;
                    "
                    @click="showForm = 2"
                    >忘记密码</span
                  >
                </p>
                <el-form-item>
                  <el-button
                    class="login-btn"
                    :loading="loading"
                    type="primary"
                    @click.native.prevent="submitForm('ruleForm1')"
                    >登录</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
            <div v-show="TabPass == 'code'">
              <el-form
                :model="ruleForm2"
                status-icon
                ref="ruleForm2"
                class="demo-ruleForm"
              >
                <el-form-item
                  prop="mobile"
                  style="text-align: center"
                  :rules="[
                    {
                      required: true,
                      message: '请输入手机号',
                      trigger: 'change',
                    },
                    {
                      pattern: /^1\d{10}$/,
                      message: '请输入正确的手机号',
                      trigger: 'change',
                    },
                  ]"
                >
                  <el-input
                    placeholder="手机号"
                    v-model="ruleForm2.mobile"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  prop="code"
                  style="text-align: center"
                  :rules="[
                    {
                      required: true,
                      message: '请输入手机验证码',
                      trigger: 'change',
                    },
                    {
                      pattern: /^\d{6}$/,
                      message: '请输入正确的手机验证码',
                      trigger: 'change',
                    },
                  ]"
                >
                  <div class="code-container">
                    <el-input
                      placeholder="手机验证码"
                      v-model="ruleForm2.code"
                      autocomplete="off"
                    ></el-input>
                    <span>
                      <el-button
                        style="float: right; width: 95%"
                        :disabled="comeFromMail"
                        :loading="getCodeLoad"
                        @click="getModifyCode(ruleForm2.mobile)"
                        >{{
                          getCodeLoad ? btnTime + "s后获取" : "获取验证码"
                        }}</el-button
                      >
                    </span>
                  </div>
                </el-form-item>
                <el-form-item
                  prop="verifycode"
                  style="text-align: center"
                  :rules="[
                    {
                      required: true,
                      message: '请输入图片验证码',
                      trigger: 'change',
                    },
                    {
                      pattern: /^\w{4}$/,
                      message: '请输入正确的图片验证码',
                      trigger: 'change',
                    },
                  ]"
                >
                  <div class="code-container">
                    <el-input
                      placeholder="验证码"
                      @keyup.enter.native="submitForm('ruleForm1')"
                      v-model="ruleForm2.verifycode"
                    ></el-input>
                    <span v-loading="loading">
                      <img
                        @click="handleChangeCode"
                        class="modify-img"
                        :src="modifySrc"
                        alt=""
                      />
                    </span>
                  </div>
                </el-form-item>
                <el-form-item>
                  <el-button
                    :loading="loading"
                    class="login-btn"
                    type="primary"
                    @click.native.prevent="submitForm('ruleForm2')"
                    >登录</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
            <p style="text-align: center">
              没有账号 ,
              <router-link to="/hrAbout?id=hr">
                <span style="color: #377cfd">马上注册</span>
              </router-link>
            </p>
          </div>
        </div>
        <div v-else-if="showForm == 2" class="form-container flex">
          <div class="logo-left">
            <img src="./../assets/login_picture1.png" class="img" />
          </div>
          <div class="login-right">
            <p style="text-align: center">
              <span
                style="
                  display: inline-block;
                  text-align: center;
                  font-size: 22px;
                  font-family: PingFangSC-Semibold;
                  font-weight: 600;
                  color: #377cfd;
                  border-bottom: 2px solid #377cfd;
                  height: 50px;
                  margin-bottom: 10px;
                "
                >找回密码</span
              >
            </p>
            <el-form
              :model="ruleForm3"
              status-icon
              ref="ruleForm3"
              label-style="text-align: center"
              class="demo-ruleForm"
            >
              <el-form-item
                prop="mobile"
                style="text-align: center"
                :rules="[
                  {
                    required: true,
                    message: '请输入手机号',
                    trigger: 'change',
                  },
                  {
                    pattern: /^1\d{10}$/,
                    message: '请输入正确的手机号',
                    trigger: 'change',
                  },
                ]"
              >
                <el-input
                  placeholder="手机号"
                  v-model="ruleForm3.mobile"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="code"
                style="text-align: center"
                :rules="[
                  {
                    required: true,
                    message: '请输入手机验证码',
                    trigger: 'change',
                  },
                  {
                    pattern: /^\d{6}$/,
                    message: '请输入正确的手机验证码',
                    trigger: 'change',
                  },
                ]"
              >
                <div class="code-container">
                  <el-input
                    placeholder="手机验证码"
                    v-model="ruleForm3.code"
                    autocomplete="off"
                  ></el-input>
                  <span>
                    <el-button
                      style="float: right; width: 95%"
                      :disabled="comeFromMail"
                      :loading="getCodeLoad"
                      @click="getModifyCode(ruleForm3.mobile)"
                      >{{
                        getCodeLoad ? btnTime + "s后获取" : "获取验证码"
                      }}</el-button
                    >
                  </span>
                </div>
              </el-form-item>
              <el-form-item
                prop="verifycode"
                style="text-align: center"
                :rules="[
                  {
                    required: true,
                    message: '请输入图片验证码',
                    trigger: 'change',
                  },
                  {
                    pattern: /^\w{4}$/,
                    message: '请输入正确的图片验证码',
                    trigger: 'change',
                  },
                ]"
              >
                <div class="code-container">
                  <el-input
                    placeholder="验证码"
                    v-model="ruleForm3.verifycode"
                  ></el-input>
                  <span v-loading="loading">
                    <img
                      class="modify-img"
                      @click="handleChangeCode"
                      :src="modifySrc"
                      alt=""
                    />
                  </span>
                </div>
              </el-form-item>
              <p style="direction: rtl" class="forgetpwd">
                <span
                  style="
                    font-size: 14px;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    color: rgba(255, 97, 97, 1);
                    line-height: 22px;
                    cursor: pointer;
                  "
                  @click="showForm = 1"
                  >已想起</span
                >
              </p>

              <el-form-item>
                <el-button
                  class="login-btn"
                  type="primary"
                  @click="handlerToReset"
                  >下一步</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div v-show="showForm == 3" class="form-container flex">
          <div class="logo-left">
            <img src="./../assets/login_picture1.png" class="img" />
          </div>
          <div class="login-right">
            <p style="text-align: center">
              <span
                style="
                  display: inline-block;
                  text-align: center;
                  font-size: 22px;
                  font-family: PingFangSC-Semibold;
                  font-weight: 600;
                  color: #377cfd;
                  border-bottom: 2px solid #377cfd;
                  height: 50px;
                  margin-bottom: 16px;
                "
                >重置密码</span
              >
            </p>
            <el-form
              :model="ruleForm4"
              status-icon
              ref="ruleForm4"
              label-style="text-align: center"
              class="demo-ruleForm"
            >
              <el-form-item
                prop="pass"
                style="text-align: center"
                :rules="[
                  {
                    required: true,
                    message: '请输入登录密码',
                    trigger: 'change',
                  },
                  {
                    pattern: /^[\w_!@#-.]{6,16}$/,
                    message: '密码为6-16位（字母，数字，!@#_-. ）',
                    trigger: 'change',
                  },
                ]"
              >
                <el-input
                  placeholder="新密码"
                  type="password"
                  v-model="ruleForm4.pass"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="repass"
                style="text-align: center"
                :rules="[
                  {
                    required: true,
                    message: '请确认登录密码',
                    trigger: 'change',
                  },
                  {
                    pattern: /^[\w_!@#-.]{6,16}$/,
                    message: '密码为6-16位（字母，数字，!@#_-. ）',
                    trigger: 'change',
                  },
                ]"
              >
                <el-input
                  placeholder="重复新密码"
                  type="password"
                  v-model="ruleForm4.repass"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  class="login-btn"
                  type="primary"
                  @click="handlerReset"
                  >重置</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- <div class="btm-b">鄂ICP备18021828号-2</div>s -->
      </el-col>
      <el-col class="pass-container" v-else-if="accontPass == 1">
        <img src="../assets/pass.png" alt />
        <p>您的信息已提交，系统还在审核中，请耐心等待</p>
      </el-col>
      <el-col class="pass-container" v-else-if="accontPass == 3">
        <img src="../assets/nopass.png" alt />
        <p>您{{ errorInfo }}，系统审核不通过，请点击下方进行信息修改</p>
        <el-button
          class="login-btn"
          style="width: 200px; margin-top: 50px"
          type="primary"
          @click="toModify"
          >修改信息</el-button
        >
      </el-col>
      <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false">
        <img width="100%" :src="dialogImageUrl" alt />
      </el-dialog>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import { constants } from "crypto";
import Cookie from "js-cookie";

// @ is an alias to /src
import {
  openloginPcEnt,
  openSessionid,
  opensmsloginPcEnt,
  openVerifyCode,
  resetPwd,
} from "@/api/login.js";

export default {
  name: "login",
  components: {},
  data() {
    return {
      accontPass: 0,
      loading: false,
      showForm: 1,
      checkVisible: false,
      checked: false,
      dialogVisible: false,
      dialogImageUrl: "",
      activeName: "first",
      fileList1: [],
      fileList2: [],
      ruleForm1: {},
      ruleForm2: {
        mobile: "",
        mobileCode: "",
        num: "",
      },
      ruleForm3: {},
      ruleForm4: {},
      TabPass: "pass",
      modifyObj: "",
      modifyCode: "",
      modifySrc: "",
      getCodeLoad: false,
      btnTime: 60,
      comeFromMail: false,
      modifyId: "",
      errorInfo: "",
      sessionid: "",
      app: "SALARY",
      token: "",
    };
  },
  methods: {
    hidedialog(e) {
      console.log(e.target.className);
      if (e.target.className != "tipList") {
        this.$store.state.showTip = false;
      }
    },
    handlerToReset() {
      this.$refs["ruleForm3"].validate(async (valid) => {
        if (valid) {
          const { data } = await opensmsloginPcEnt({
            mobile: this.ruleForm3.mobile,
            code: this.ruleForm3.code,
            sessionid: this.sessionid,
            verifycode: this.ruleForm3.verifycode,
            app: this.app,
          });
          if (data.code == 200) {
            this.token = data.data;
            this.showForm = 3;
          } else {
            this.$notify({
              title: "警告",
              message: data.msg || "网络异常",
              type: "warning",
            });
            this.handleChangeCode();
          }
          this.loading = false;
        } else {
          this.$message({
            message: "请将信息填写完整",
            type: "warning",
          });
          this.handleChangeCode();
          return false;
        }
      });
    },
    async handlerTab(type = "pass") {
      this.TabPass = type;
      this.modifyObj = await this.getCode();

      // this.modifySrc = this.modifyObj[this.modifyCode]
      this.modifySrc = "data:image/png;base64," + this.modifyObj;
      console.log(type);
    },
    handlerReset() {
      this.$refs["ruleForm4"].validate((valid) => {
        if (valid && this.ruleForm4.pass == this.ruleForm4.repass) {
          resetPwd({
            newPassword: this.ruleForm4.pass,
            token: this.token,
          }).then(() => {
            this.showForm = 1;
            this.getCodeLoad = false;
            this.btnTime = 60;
            this.ruleForm1 = {};
            this.$notify({
              title: "成功",
              message: "密码重置成功",
              type: "success",
            });
          });
        } else {
          this.$message({
            message: "请将信息填写完整",
            type: "warning",
          });
          this.handleChangeCode();
          return false;
        }
      });
    },
    onArgeen(val) {
      if (val == "ok") {
        this.checkVisible = false;
        this.checked = true;
      } else {
        this.checkVisible = false;
        this.checked = false;
      }
    },
    async getCode() {
      this.loading = true;
      // let res = await this.$http.get('/customer/captcha')
      // let url =  this.$http.defaults.baseURL+'/customer/captcha';
      // let res =await axios.get(url)
      //  let res = await this.$http.get('/customer/captcha')
      let res1 = await openSessionid();
      this.sessionid = res1.data;
      let res2 = await openVerifyCode({
        sessionid: this.sessionid,
      });

      this.loading = false;
      return res2.data;
    },
    getModifyCode(test) {
      let phoneReg = new RegExp(/^1\d{10}$/);
      if (phoneReg.test(test)) {
        this.btnTime = 60;
        this.getCodeLoad = true;
        var timer = setInterval(() => {
          this.btnTime--;
          if (this.btnTime <= 0) {
            this.getCodeLoad = false;
            clearInterval(timer);
          }
        }, 1000);
        this.$http
          .post(`/authority-center/open/login/sms_code?mobile=${test}`)
          .then(
            (res) => {
              if (res.data.code == 200) {
                this.$notify({
                  title: "成功",
                  message: "验证码已发送至手机，请注意查收",
                  type: "success",
                });
              } else {
                this.$notify({
                  title: "警告",
                  message: res.data.msg || "网络异常",
                  type: "warning",
                });
              }
            },
            (error) => {
              this.btnTime = 0;
            }
          );
      } else {
        this.$message({
          message: "请填写正确的手机号码",
          type: "warning",
        });
      }
    },
    OnCheck() {
      this.checkVisible = true;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    submitForm(formName) {
      switch (formName) {
        case "ruleForm1":
          this.$refs[formName].validate(async (valid) => {
            if (valid) {
              this.loading = true;
              const { data } = await openloginPcEnt({
                username: this.ruleForm1.username,
                password: this.ruleForm1.password,
                sessionid: this.sessionid,
                code: this.ruleForm1.code,
                app: this.app,
              });
              if (data.code == 200) {
                Cookie.set("token", `${data.data}`, {
                  expires: 1,
                  path: "/",
                  domain: ".joyousoa.com",
                });
                Cookie.set("token", `${data.data}`, {
                  expires: 1,
                  path: "/",
                  domain: "192.168.18.134",
                });
                Cookie.set("token", `${data.data}`, {
                  expires: 1,
                  path: "/",
                  domain: ".prosuntech.com",
                });
                window.sessionStorage.setItem("token", data.data + "");
                this.$router.push("/productList");
                this.loading = false;
              } else {
                this.$notify({
                  title: "警告",
                  message: data.msg || "网络异常",
                  type: "warning",
                });
                this.handleChangeCode();
                this.loading = false;
              }
            } else {
              this.$message({
                message: "请将信息填写完整",
                type: "warning",
              });
              this.handleChangeCode();
              return false;
            }
          });
          break;
        case "ruleForm2":
          this.$refs[formName].validate(async (valid) => {
            if (valid) {
              this.loading = true;
              const { data } = await opensmsloginPcEnt({
                mobile: this.ruleForm2.mobile,
                code: this.ruleForm2.code,
                sessionid: this.sessionid,
                verifycode: this.ruleForm2.verifycode,
                app: this.app,
              });

              if (data.code == 200) {
                this.$notify({
                  title: "成功",
                  message: "登录成功",
                  type: "success",
                });
                Cookie.set("token", `${data.data}`, {
                  expires: 1,
                  path: "/",
                  domain: ".joyousoa.com",
                });
                Cookie.set("token", `${data.data}`, {
                  expires: 1,
                  path: "/",
                  domain: "192.168.18.134",
                });
                Cookie.set("token", `${data.data}`, {
                  expires: 1,
                  path: "/",
                  domain: ".prosuntech.com",
                });
                window.sessionStorage.setItem("token", data.data + "");
                this.$router.push("/productList");
                this.loading = false;
              } else {
                this.$notify({
                  title: "警告",
                  message: data.msg || "网络异常",
                  type: "warning",
                });
                this.handleChangeCode();
                this.loading = false;
              }
            } else {
              console.log(data);
              this.$message({
                message: "请将信息填写完整",
                type: "warning",
              });
              this.handleChangeCode();
              return false;
            }
          });
          break;
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    toModify() {
      this.$router.replace("/hrModifyAbout");
    },
    async handleChangeCode() {
      this.modifyObj = await this.getCode();

      // this.modifySrc = this.modifyObj[this.modifyCode]
      this.modifySrc = "data:image/png;base64," + this.modifyObj;
    },
  },
  async mounted() {
    // if(Cookie.get('token')){
    //   window.sessionStorage.setItem('token',Cookie.get('token'))
    //   this.$router.push('/productList')
    //   this.loading = false;
    //   return;
    // }
    this.modifyObj = await this.getCode();

    // this.modifySrc = this.modifyObj[this.modifyCode]
    this.modifySrc = "data:image/png;base64," + this.modifyObj;
  },
  watch: {
    async showForm(val) {
      this.modifyObj = await this.getCode();

      // this.modifySrc = this.modifyObj[this.modifyCode]
      this.modifySrc = "data:image/png;base64," + this.modifyObj;
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  height: 100vh;
  background: url("./../assets/login_newbg.png") no-repeat;
  background-size: 100% 100%;
}

.flex {
  display: flex;
}

.logo-left {
  width: 232px;

  .img {
    width: 100%;
  }
}

.login-right {
  flex: 1;
  padding: 37px 56px;
}

.forgetpwd {
  margin-top: -19px;
}

header {
  width: 95%;
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .header-img {
    // margin: 15px 40px;
    // height: 60px;
    // style="margin: 15px 40px; width: 200px; height: 60px"
  }
}

.tel {
  color: #377cfd;
  font-size: 16px;
  margin-right: 40px;
}

.bg-container {
  position: relative;

  .bg-1 {
    position: absolute;
    width: 80%;
    height: 40vh;
    background: url("../assets/card/111.png") no-repeat;
    background-size: auto 90%;
    z-index: -1;
  }

  .bg-3-1 {
    position: absolute;
    width: 13vw;
    height: 28px;
    top: 18vh;
    left: 13vw;

    // background: pink;
    img {
      width: 100%;
    }
  }

  .bg-3-2 {
    position: absolute;
    width: 8vw;
    height: 28px;
    top: 24vh;
    left: 13vw;

    // background: pink;
    img {
      width: 100%;
    }
  }

  .bg-3-3 {
    position: absolute;
    width: 75px;
    height: 28px;
    top: 29vh;
    left: 13vw;

    // background: pink;
    img {
      width: 100%;
    }
  }

  .bg-3-4 {
    position: absolute;
    width: 10vw;
    height: 28px;
    top: 32vh;
    left: 13vw;

    // background: pink;
    img {
      width: 100%;
    }
  }

  .bg-3-6 {
    position: absolute;
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 43px;
    top: 44vh;
    left: 13vw;
  }

  .bg-3-7 {
    position: absolute;
    font-size: 22px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 43px;
    top: 40vh;
    left: 13vw;
  }

  .bg-3-8 {
    position: absolute;
    font-size: 22px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 43px;
    top: 45vh;
    left: 13vw;

    .orange {
      color: #ffa52e;
    }

    .red {
      color: #e6212a;
    }
  }

  .bg-3-5 {
    position: absolute;
    width: 32vw;
    height: 28px;
    top: 52vh;
    left: 8vw;

    // background: pink;
    img {
      width: 100%;
    }
  }
}

.modify-img {
  height: 40px;
  // width: 90%;
}

// .el-icon-questio{
//   float:right;
//   font-size:22px;
//   margin:15px 24px;
//   margin-top: 30px;
//   background-color: #000;
//   width:174px;
//   height:50px;
//   font-size: 16px;
//   color: #ccc;
// }
.hover-i {
  float: right;
  color: rgba(131, 143, 153, 1);
  font-size: 16px;
  cursor: pointer;
  position: relative;

  &:hover {
    &:after {
      position: absolute;
      bottom: -30px;
      right: 0px;
      width: 300px;
      height: 30px;
      line-height: 30px;
      border-radius: 10px;
      font-size: 12px;
      color: rgba(44, 45, 58, 1);
      text-align: center;
      background: rgba(243, 245, 247, 1);
      border-radius: 4px;
      content: "如有疑问，请致电客服热线：18971608045";
    }
  }
}

.pass-container {
  text-align: center;

  img {
    margin-top: 100px;
    height: 144px;
    width: 144px;
  }

  p {
    margin-top: 25px;
    font-size: 20px;
    font-weight: 600;
    color: rgba(44, 45, 58, 1);
  }
}

.login-btn {
  width: 100%;
  margin-top: 13px;
  background: #377cfd;
  border-radius: 28px;
  border-color: #377cfd;

  &:hover {
    background: rgba(55, 124, 253, 0.7);
    border-color: rgba(55, 124, 253, 0.7);
  }
}

.active_a {
  color: #377cfd !important;
  border-bottom: 2px solid #377cfd;
}

.code-container {
  display: flex;

  .el-input {
    flex: 3;
  }

  span {
    flex: 2;
  }
}

.form-container {
  margin-top: 13vh;
  // padding: 37px 56px;
  box-shadow: 0px 4px 16px 0px rgba(131, 143, 153, 0.15);
  border-radius: 16px;
  width: 696px;
  height: 417px;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  background: #fff;

  // &::after {
  //   content: '鄂ICP备18021828号-2';
  //   width: 100%;
  //   text-align: center;
  //   display: inline-block;
  //   padding: 15px 0;
  // }
  &-header {
    display: flex;

    span {
      flex: 1;
      text-align: center;
      font-size: 22px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      color: rgba(59, 196, 146, 1);
      height: 50px;
      margin-bottom: 16px;

      a {
        color: rgba(131, 143, 153, 1);
        display: inline-block;
        height: 100%;
      }
    }
  }
}

// .reset{
//   width:500px;
//   padding: 37px 56px;
// }
.btm-b {
  // width: 464px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #838f99;
  line-height: 22px;
  text-align: center;
  margin-top: 24px;
}

.online {
  width: 160px;
  height: 46px;
  background: #377cfd;
  box-shadow: 0px 8px 16px 0px rgba(59, 196, 146, 0.15);
  border-radius: 28px 0px 0px 28px;
  position: absolute;
  bottom: -15px;
  right: 0;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

// &::after {
//   content: '鄂ICP备18021828号-2';
//   width: 100%;
//   text-align: center;
//   display: inline-block;
//   padding: 15px 0;
// }
@media (min-width: 300px) and (max-width: 768px) {
  .login-right {
    flex: 1;
    padding: 37px 10px;
  }

  .logo-left {
    display: none;
  }

  .bg-3-1 {
    display: none;
  }

  .bg-3-2 {
    display: none;
  }

  .bg-3-3 {
    display: none;
  }

  .bg-3-4 {
    display: none;
  }

  .bg-3-5 {
    display: none;
  }

  .bg-3-6 {
    display: none;
  }

  .bg-3-7 {
    display: none;
  }

  .bg-3-8 {
    display: none;
  }

  .header-img {
    width: 180px;
    margin-left: 10px;
    margin-top: 9px;
  }

  .tel {
    margin-right: 10px;
  }

  .bg-container .bg-2 {
    /*top: unset;*/
    bottom: 0;
  }

  .form-container {
    width: 95%;
    background-color: #fff;
    margin-top: 150px;
  }

  .login {
    height: 100vh;
    background: url("./../assets/login_newbg.png") no-repeat;
    background-size: 100% 100%;
  }

  .bg-container {
    .bg-1 {
      width: 40%;
      height: 20vh;
    }

    .bg-3 {
      display: none;
    }
  }

  .my-inbox {
    top: 100% !important;
    transform: translate(-50%, 0) !important;
  }
}

.my-inbox {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 664px;
  max-width: 100%;
  height: 40px;
  line-height: 34px;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.3);
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.7);
  box-sizing: border-box;

  .my-uname {
    white-space: nowrap;
    display: inline-block;
    color: #fff;
    font-size: 24px;
    animation: 20s wordsLoop linear infinite normal;
  }
}

@keyframes wordsLoop {
  0% {
    transform: translateX(664px);
  }

  100% {
    transform: translateX(-100%);
  }
}

.redFont {
  color: #ff0000;
  font-weight: 600;
}

.form-container-header span {
  margin-bottom: 10px;
}
</style>
